import { useMemo } from 'react'

import { useKindeAuth } from '@kinde-oss/kinde-auth-react'

export function useUserEmail() {
  const { user, isAuthenticated, isLoading } = useKindeAuth()

  return useMemo(() => {
    if (isLoading) {
      return undefined
    }
    if (!isAuthenticated) {
      return undefined
    }
    return user?.email
  }, [isLoading, isAuthenticated, user])
}
